window.addEventListener("load", function () {
  // Thêm audio tag khi trang load xong
  var musicUrl = $("#MS__wrapper").data("audio") || $("body").data("audio");

  if (musicUrl) {
    var audioElement = $('<audio id="backgroundMusic" loop></audio>');
    audioElement.append('<source src="' + musicUrl + '" type="audio/mpeg">');
    $("body").append(audioElement);

    var audio = document.getElementById("backgroundMusic");
    var hasInteracted = false;
    var manuallyPaused = false; // Track nếu user click nút music để pause

    // Tự động bật nhạc khi người dùng tương tác lần đầu
    var autoPlayHandler = function (e) {
      if (
        !hasInteracted &&
        !$(e.target).hasClass("music") &&
        !$(e.target).closest(".music").length &&
        !$(e.target).hasClass("sound__character") &&
        !$(e.target).closest(".sound__character").length
      ) {
        hasInteracted = true;
        audio
          .play()
          .then(function () {
            $(".music").removeClass("offmusic");
            manuallyPaused = false;
          })
          .catch(function (error) {
            console.log("Autoplay prevented:", error);
          });
        $(document).off("click", autoPlayHandler);
      }
    };
    $(document).on("click", autoPlayHandler);

    // Xử lý nút music để play/pause
    $(".music").on("click", function (e) {
      e.preventDefault();
      hasInteracted = true;
      $(document).off("click", autoPlayHandler);

      if (audio.paused) {
        audio
          .play()
          .then(function () {
            $(".music").removeClass("offmusic");
            manuallyPaused = false;
          })
          .catch(function (error) {
            console.log("Audio play error:", error);
          });
      } else {
        audio.pause();
        $(this).addClass("offmusic");
        manuallyPaused = true;
      }
    });

    // Pause music khi page bị ẩn (chuyển tab, minimize, scroll ra ngoài)
    document.addEventListener("visibilitychange", function () {
      if (document.hidden) {
        // Page bị ẩn - pause music
        if (!audio.paused) {
          audio.pause();
        }
      } else {
        // Page quay lại visible - resume music nếu user không tắt nó
        if (hasInteracted && !manuallyPaused && audio.paused) {
          audio.play().catch(function (error) {
            console.log("Audio resume error:", error);
          });
        }
      }
    });
  }
});
